/*
 * @Author: pangshuting 2723947616@qq.com
 * @Date: 2022-04-18 09:09:30
 * @LastEditors: pangshuting 2723947616@qq.com
 * @LastEditTime: 2022-06-08 16:16:14
 * @FilePath: \rotateActivity\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import tupHttp from './util/service'
import VueResource from 'vue-resource'
import LuckDraw from 'vue-luck-draw'
import ElementUI from 'element-ui'
//加密库
window.CryptoJS = require("crypto-js");
// 也可以全局引入样式
import 'element-ui/lib/theme-chalk/index.css';


Vue.use(ElementUI)
Vue.use(LuckDraw)
Vue.use(MintUI)
Vue.use(tupHttp)
Vue.use(VueResource)
import 'lib-flexible'
import Vconsole from 'vconsole'
if (process.env.NODE_ENV === "development") { //开发版才开启日志
    let vConsole = new Vconsole()
    Vue.use(vConsole)
}
// 控制标签宽高成比例的指令
import proportion from 'vue-proportion-directive';
Vue.use(proportion);
Vue.config.ignoredElements = ['wx-open-launch-app', 'wx-open-launch-weapp'];
Vue.config.productionTip = false
    //请求发起时做拦截
Vue.http.interceptors.push(function(request, next) {
    request.headers.set('authToken', window.sessionStorage.getItem('token')) //存放token
    request.headers.set('x_auth_token', window.sessionStorage.getItem('token'))
    request.headers.set('x_user_id', window.sessionStorage.getItem('x_user_id')) //存放memberid
    request.headers.set('x_request_platform', 'H5') //设置请求头
})
window.onresize = setHtmlFontSize;

function setHtmlFontSize() {
    const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
    const htmlDom = document.getElementsByTagName('html')[0];
    htmlDom.style.fontSize = htmlWidth / 10 + 'px';
};
setHtmlFontSize();


//PC端UI框架
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI);

// require('./util/rem.js')


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js